import { queries } from "@testing-library/react";

export const PRODUCT_LIST = {
  DASHBOARD_OVERVIEW_ASSIST_AI: "DASHBOARD_OVERVIEW_ASSIST_AI",
  DASHBOARD_OVERVIEW_AUTHOR_AI: "DASHBOARD_OVERVIEW_AUTHOR_AI",
  ASK_YOUR_DATA: "ASK_YOUR_DATA",
  DASHBOARD_OVERVIEW_ASK_YOUR_DATA: "DASHBOARD_OVERVIEW_ASK_YOUR_DATA",
  DASHBOARD_OVERVIEW_CALLAI: "DASHBOARD_OVERVIEW_CALLAI",
  DASHBOARD_OVERVIEW_PROMPT_AI: "DASHBOARD_OVERVIEW_PROMPT_AI",
}
export const STATUS_CODE = {
  OK: 200,
  BAD_REQUEST: 403,
  INTERNAL_SERVER_ERROR: 500,
  CREATED: 201,
  UNAUTHORIZED: 401,
  PRECONDITION_FAILED: 412,
};
export const BUTTON_ACTIONS = {
  DELETE: "Delete",
  SAVE: 'Save',
  CHANGE: 'Change',
  CLEAR: 'Clear',
  YES: "Yes"
}
export const SET_DEFAULT_VALUE = {
  DEFAULT: "default"
}
export const Messages_ROLE = {
  USER: 'user',
  ASSISTANT: "assistant",
  assistant: 'ASSISTANT',
  user: "USER"
}
export const ROUTES_NAME = {
  TASKPDF: '/taskpdf',
  KB_UTILITY: '/kbutility',
  DASHBOARD: '/dashboard',
  AGENT_CHAT: "/agentChat",
  DOORDASH_POC: '/doordashPOC',
  MANAGE_CHATBOT: '/manageChatbot',
  MANAGE_USER: "/manageUsers",
  MASTER_CONFIGURATION: "/masterConfiguration",
  MANAGE_PROMPTAI: "/managePromptAI",
}
export const TIMEZONE = {
  US: "en-US",
};
export const USERS_FORM = {
  users_id: "users_id",
};
export const USER_INPUT = {
  CHAT_HISTORY_RESPONSE_PREFIX: "chat_history_",
  RESPONSE_PREFIX: "/responses/",
  AUTO_SUGGESTION_PREFIX: "auto_suggest",
};
export const AI_MODEL_COMPONENT = {
  aiModel: "openai",
  PaLM2: "PaLM2",
};
export const REPORTS = {
  CONVERSATION_HISTORY_LOGS: "CONVERSATION_HISTORY_LOGS",
  CONVERSATION_HISTORY_LOGS_HEADING: "Conversation History",
  NUMBER_OF_DAYS: 45,
  ACTIVE_USER_STATS: "Distinct Users",
  INTERACTION_LOGS: "Interaction Logs",
  PRODUCT_REPORTS: "PRODUCT_REPORTS",
  LOGS_REVIEW_REPORT: "LOGS_REVIEW_REPORT",
  LOGS_REVIEW_SUMMARY: "LOGS_REVIEW_SUMMARY",
  AUDIT_LOGS: 'AUDIT_LOGS',
  AUDIT_LOGS_SUMMARY: 'AUDIT_LOGS_SUMMARY',
  AVERAGE_USER_STATS: "AVERAGE_USER_STATS",
  WEIGHTED_AVARAGE_USER_STATS: "Daily Active Users (DAU)",
  ASSIST_AI_ADOPTION_FEEDBACK_REPORT: "ASSIST_AI_ADOPTION_FEEDBACK_REPORT",
  ASSIST_AI_ADOPTION_FEEDBACK_REPORT_HEADING: "AssistAI Adoption and Feedback Report",
  TASKGPT_PRODUCT_FEEDBACK_REPORTS_HEADING: "Product Feedback",
  TASKGPT_PRODUCT_FEEDBACK_REPORTS: "TASKGPT_PRODUCT_FEEDBACK_REPORTS",
  TASKVOICE_AUDIT_LOGS: 'TASKVOICE_AUDIT_LOGS'
};
export const RESPONSE_MESSAGE = {
  SIZE_ERROR: "File Should be smaller than ",
  TYPE_ERROR_PDF: "File Should be PDF/DOC/TXT/PPTX",
  FILE_UPLOADING_FAILED_MESSAGE: "File Uploading failed, please try again",
  TYPE_ERROR_CSV: "File Should be CSV",
  TYPE_ERROR_HR_ARTICLE: "File Should be PDF/TXT/DOC",
  TYPE_ERROR_IMAGE: "File Should be PNG or JPG",
  FILE_SUCCESS: "File Successfully Uploaded.",
  FILE_ERROR: "File Not Uploaded!",
  FILE_NOT_DOWNLOAD: "File Cannot be Downloaded",
  AUTHOR_AI_ALREADY_EXITS: "AuthorAI already exist.",
  DUPLICATE_FILE_ERROR: "Can't select duplicate file!",
  CHAT_CLEAR: "Chat cleared",
  SESSION_TIMEOUT:
    "Session expired due to inactivity, redirecting to login screen!",
  LOGGED_OUT_MESSAGE: "You have been logged out successfully!",
  UNABLE_TO_LOGIN: "Unable to Login!",
  SOMETHING_WENT_WRONG: "Something Went Wrong, Please Try Again",
  REQUIRED_FIELD: "Please Select Required Fields!",
  CHATBOT_CREATED: "Chatbot created successfully.",
  CHATBOT_UPDATED: "AssistAI updated successfully.",
  ASKYOURDATA_UPDATED: "AskYourData updated successfully.",
  PROMPT_AI_UPDATED: "PromptAI updated successfully.",
  PROMPT_AI_CREATED: "PromptAI has been created successfully.",
  CHATBOT_NOT_FOUND: "Chatbot Not Found",
  JSON_CONFIG_ERROR: "Json Config is not Correct",
  INTERNAL_SERVER_ERROR: "Internal Server Error",
  ROLE_UPDATED: "Role updated successfully",
  PDF_RECORD_DELETE: "Record deleted successfully",
  PDF_RECORD_UPDATED: "Record updated successfully",
  USER_SUCCESS: "User successfully created!",
  USER_UPDATE_SUCESS: "User successfully updated!",
  USER_FAILURE: "User not updated!",
  INVALIDE_EMAIL: "Invalid Email!",
  INVALIDE_EMPLOYEE_CODE: "Employee Code should not contain spaces!",
  INVALIDE_LINK: "Invalid Link!",
  TYPE_ERROR_FILES: "File Should be PDF/DOC/CSV",
  knowledgeBaseVersion: "Knowledge Repository not linked. Please link a knowledge repository to enable the chatbot.",
  UPDATE_HELP_QUESTIONS: "Help questions updated successfully.",
  FILEUPLOADING_CANCEL: "This will cancel the file uploading.",
  CONFIRM_CHAT_TYPE_TITLE: 'Change Chat Type Confirmation',
  CONFIRM_CHAT_TYPE_TEXT: 'Are you sure you want to proceed? This action will result in the removal of the uploaded document(s) and associated chat history.',
  EDIT_CHAT_TYPE_TITLE: "Are you sure want to change chat type?",
  EDIT_CHAT_TYPE_TEXT: "Are you sure? Changing the document(s) settings may affect downstream visibility.",
  REPOSITORY_CREATED_SUCCESS: "Repository created successfully.",
  REPOSITORY_CREATED_ERROR: "Something is not correct.",
  REPOSITORU_ARCHIVED_SUCCESS: "Repository archived successfully.",
  REPOSITORU_ARCHIVED_ERROR: "Something is not correct.",
  TYPE_ERROR_AUDIO: "File Should be WAV/MP3",
  AUDIO_RECORD_DELETE: "Record deleted successfully",
  AUDIO_RECORD_UPDATED: "Record updated successfully",
  CLEAR_CHAT_TEXT: "Are you certain? This action will delete the conversation history for these document(s).",
  CHAT_DELETION: "Confirm Chat Deletion",
  CHAT_CONVERSATIONS: "Clear Chat Conversations",
  CHANGE_TYPE_CONFIRMATION: "Change Chat Type Confirmation",
  UNABLE_TO_GET_SIGNED_URL: "Unable to get Signed Url",
  UNAUTHORIZED_USER: "Unauthorized User",
  CHATBOT_ALREADY_EXIST: "Chatbot already exist.",
  ASKYOURDATA_ALREADY_EXIST: "AskYourData already exist.",
  PROMPT_AI_ALREADY_EXIST: "PromptAI already exist.",
  SELECT_CHATBOT: "Please Select Chatbot",
  SELECT_ASK_YOUR_DATA: "Please Select AskYourData",
  SELECT_AUTHORAI: "Please Select AuthorAI",
  SELECT_REPORT_TYPE: "Please Select Report Type",
  SELECT_DATE: "Please Select Date",
  END_DATE_ERROR: 'End date should be greater than Start date.',
  DATE_RANGE_EXCEEDED: 'Date Range cannot exceed ' + REPORTS.NUMBER_OF_DAYS + " days.",
  CHANGE_STATUS: 'User status changed successfully',
  USER_ACTION_CANCEL: 'User has canceled this process.',
  USER_ACTION_EXPIRE: 'User Action has timed out.',
  CONFIRM_CONVERSATIONS_DELETION: "Confirm Conversations Deletion",
  CONFIRM_CONVERSATIONS_DELETION_DESCRIPTION: "Are you sure you want to proceed? This action will result in the removal of the all conversation(s)",
  CLEAR_CONTEXT_MESSAGE: "Context cleared for this conversation",
  PLAYGROUND_TEXT: "Are you sure you want to disable the playground?",
  PLAYGROUND_TITLE: "Disabling Playground",
};
export const API_RESPONSE = {
  SUCCESS: 'success',
  FAILURE: 'failure'
}
export const PROMPT_AI_METRICS = {
  "duplicatePrompt": "Duplicate Prompts",
  "duplicateResponse": "Duplicate Responses",
  "shortPrompt": "Short Prompts",
  "longResponse": "Long Responses",
  "totalSuggestionsCount": "Entries"
}
export const CHATBOT_MENUS = {
  TITLE: "TaskGPT",
  TITLE_MOBILE: " TaskGPT",
  MONEYLION: "moneylion",
  MONEYLION_CAPS: "MONEYLION",
  FEDEX: "fedex",
  ETSY: "etsy",
  UBER: "uber",
  VIVINT: "vivint",
  TURO: "turo",
  YOHANA: "yohana",
  PAWSIBILITY: "pawsibility",
  PWASIBILITY: "pwasibility",
  MENTAL_HEALTH_ASSISTANT: "mental health assistant",
  ARTICLE_GENERATOR: "article generator",
  PROMPTO: "promptai",
  HOME: "home",
  AGENT_CHAT: "Teammate",
  CUSTOMER_CHAT: "Customer",
  PROFILE: "profile",
  VEHO: "veho",
  CHIME: "chime",
  WALMART: "walmart",
  BOX: "box",
  PROXIMA: "proxima",
  REPORTS: "Analytics",
  OBSERVABILITY: "Observability",
  CHATBOTS: "AssistAI",
  ASK_YOUR_DATA: "AskYourData",
  LOGOUT: "Logout",
  MANAGECHATBOT: "manage AssistAI",
  TaskPDF: "taskpdf",
  taskpdf: "TaskPDF",
  TaskAUDIO: "taskaudio",
  taskaudio: "TaskAUDIO",
  LIZ: "liz",
  DOORDASH: "doordash",
  AMC: "amc",
  MAILCHIMP: "mailchimp",
  ACORNS: "acorns",
  MISSIONLANE: "missionlane",
  SHOPIFY: "shopify",
  WAYMO: "waymo",
  BREX: "brex",
  NAB: "nab",
  ROBINHOOD: "robinhood",
  GUSTO: "gusto",
  MHA: "mha",
  SEATGEEK: "seatgeek",
  VIVIDSEATS: "vividseats",
  ZOOM: "zoom",
  DASHBOARD: "dashboard",
  MANAGEUSERS: "manage users",
  MANAGE_ROLES: "Manage Roles",
  MANAGE_USERS: "Manage Users",
  MANAGE_PROMPTAI: "Manage PromptAI",
  POC: "POC",
  KB_UTILITY: "TaskKB",
  FEEDBACK: "FEEDBACK",
  TASKSCRIBE: 'AuthorAI',
  PROMPT_AI: "PromptAI",
};
export const FILE_SIZE = {
  MB_20: 20485760,
  MB_20_text: "20MB",
  MB_10: 10485760,
  MB_10_text: "10MB",
  MB_3: 3145728,
  MB_3_text: "3MB",
  KB_10: 10240,
  KB_10_text: "10KB",
};
export const SMALL_TALK = {
  MASTER_API: "master",
  CHATBOT_API: "CHATBOT"
}
export const FILE_TYPE = {
  PDF: "application/pdf",
  DOC: "application/msword",
  DOCX: ".docx",
  TXT: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  POWER_POINT: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  CSV: "text/csv",
  TXTPLAN: "text/plain",
  AIFC: "audio/x-aiff",
  AIFF: "audio/x-aiff",
  MP2: "audio/mpeg",
  MP3: "audio/mpeg",
  M4A: "audio/mp4",
  OGG: "application/ogg",
  WAV: "audio/wav",
};
export const DATA_FORMAT = {
  TEXT: 'text',
  IMAGE: 'image',
  TABLE: 'table',
  CHART_JSON: 'json',
}
export const ROLE_TYPE = {
  USER: "user",
  ASSISTANT: "assistant",
  ADMIN: "Admin",
};

export const APPLICATION_LOCAL_STORAGE = {
  REFRESH_TOKEN: "refreshToken", // use for regenerate the authtoken
  CLIENT_API_RESPONSE: "clientAPIResponse",
  TOKEN_TIME_STAMP: "tokenTimestamp", // last authtoken generation timestamp.
  SESSION_TIMEOUT_IN_MILLI_SECONDS: "sessionTimeoutInMilliseconds",
  VISIBLE_PLAYGROUND_INSTRUCTION: "VISIBLE_PLAYGROUND_INSTRUCTION",
  CONFIG_SETTING_DATA: "CONFIG_SETTING_DATA", // STORE all data coming from
  AUTH_TOKEN: "authToken", // User auth token
  REFRESH_TOKEN_LAST_UPDATED_AT: "refreshTokenLastUpdatedAt", //  This is only for view purpose
  LOGIN: "login",
  CLIENT_TYPE: "clientType",
  LOGOUT_FLAG: "logout_flag",
  IS_RELOGIN_ACTION: "isReloginAction",
  JSON_OBJECT: "jsonObject",
  PING_ACCESS_TOKEN: "pingAccessToken", // Ping Auth Token
  AUTH_TYPE: "authType",
  USER_DETAILS: "userDetail",
  CHATBOT_ACTIVE: "chatbotactive",
  REPORT_ACTIVE: "reportActive",
  AUTHOR_AI_ACTIVE: "authorAiActive",
  OBSERVIBILITY_ACTIVE: "observibilityActive",
  SELECTED_CHATBOT_EXTENSION: "selectedChatBotExtension",
  ACTIVE_MENU: "activeMenu",
  USER_EMAIL: "userEmail",
  SESSION_CLOSED: "sessionClosed",
  SELECTEDCHIP: "selectedChip",
  CURRENT_RESPONSE_STATUS: "currentResponseStatus",
  SESSION_TIMEOUT: "sessionTimeOut",
  POC_DETAILS: "pocDetails",
  THEME_TYPE: 'themeType',
  INPUT_LOGIN: 'input_login',
  ACTIVATE_BCM: 'activateBCM',
  IS_DATA_VIZ_ENABLED: "isDataVizEnabled",
  SWITCH_ROLE: "switchRoleData",
  SERVICE_DETAILS: "servicedetails",
  TASKPDF_SERVICE_DETAILS: "taskpdf_servicedetails",
  TASKSCRIBE_SERVICE_DETAILS: "taskscribe_servicedetails"
  // USER_ROLE: "userRole" // Remove by @Ashwani as it is not in use.
};
export const EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const AUTH_TYPE = {
  PING_AUTH: "PING_AUTH",
  PASSCODE_AUTH: "PASSCODE_AUTH",
  CF_AUTH: "CF_AUTH",
};

export const APPLICATION_CLIENTS = {
  SELF: "self",
  EXTENSTION: "extension",
};
export const AUTH_TOKEN_GENERATION_TIME_IN_SEC = 5000;
export const FLOATING_WIDGET_PATH_URL = "floatingwidget";
export const REDIRECTION_PAGE = {
  FLOATING_WIDGET_ERROR_PAGE: "/error", // Error page design only for floating widget
  LOGIN_PAGE: "/login", // use only for web application
  HOME: "/home",
  FLOATING_WIDGET: "chatbot/floatingwidget?&authToken=",
  LOGOUT_PAGE: "/logout?",
  CUSTOMER_CHAT: "customerChat",
  AGENT_CHAT: "agentChat"
};

export const FILE_PROCESSING_STATUS = {
  FINISHED: "FINISHED",
  PROCESSING: "PROCESSING",
  FAILED: "FAILED",
};
export const CHATBOT_UI_CLIENTS = {
  FLOATING_WIDGET: "Flutter",
  FULL_MODE: "Pro",
  WEB_CHATBOT: "Classic",
};
export const FLOATING_WIDGET_PARAMS = {
  AUTH_TOKEN: "authToken",
  EMAIL: "email",
  CLIENT_TYPE: "clientType",
  DATA: "data"
};

export const ARTICLE_STATUS = {
  FINISHED: "FINISHED",
  PROCESSING: "PROCESSING",
  FAILED: "FAILED",
};

export const ARTICLE_TABLE_ACTION = {
  DESC: "DESC",
  ASC: "ASC",
  createdAt: "createdAt",
};

export const CHATBOT_FORM = {
  chatbot_id: "chatbot_id",
  jsonValidation:
    "Please check the JSON value (check commas, duplicates & enclose properties in double quotes)",
};

export const FEEDBACK_TYPE = {
  product_feedback: "product_feedback",
  positive_conversation_feedback: "positive_conversation_feedback",
  negative_conversation_feedback: "negative_conversation_feedback",
};
export const PRODUCT_MODULE_TYPE = {
  promoto: "promoto",
  TASK_PDF: "task_pdf",
  TASK_AUDIO: "task_audio",
  CHATBOT: "chatbot",
  TASKSCRIBE: "TASKSCRIBE",
  ASKYOURDATA: "ASKYOURDATA",
  PROMPTOGPT: "PROMPTOGPT"
};
export const QUESTION_TYPE = {
  SINGLE_CHOICE: "SINGLE_CHOICE",
  SCALE_CHOICE: "SCALE_CHOICE",
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
  SUBJECTIVE: "SUBJECTIVE",
  CHECKBOX: "CHECKBOX",
};

export const PRIVILEGE = {
  TASKPDF: "TASKPDF",
  REPORTS: "REPORTS",
  PRODUCT_REPORTS: "PRODUCT_REPORTS",
  USER_REPORTS: "USER_REPORTS",
  MANAGE_AUTHORAI: "MANAGE_AUTHORAI",
  TASKAUDIO: "TASKAUDIO",
  KB_UTILITY: "KB_UTILITY",
  DOORDASH_AGENT: 'DOORDASH_AGENT',
  DOORDASH_USER: 'DOORDASH_USER',
  TASKSCRIBE: "TASKSCRIBE",
  AVERAGE_USER_STATS: "AVERAGE_USER_STATS",
  ASSIST_AI_ADOPTION_FEEDBACK_REPORT: "ASSIST_AI_ADOPTION_FEEDBACK_REPORT",
  TASKGPT_PRODUCT_FEEDBACK_REPORTS: "TASKGPT_PRODUCT_FEEDBACK_REPORTS",
  SHOW_ASSIST_AI_RESPONSE_METADATA: "SHOW_ASSIST_AI_RESPONSE_METADATA",
  SHOW_TASKPDF_RESPONSE_METADATA: "SHOW_TASKPDF_RESPONSE_METADATA",
  SHOW_TASKSCRIBE_RESPONSE_METADATA: "SHOW_TASKSCRIBE_RESPONSE_METADATA",
  SWITCH_ROLE: "SWITCH_ROLE",
  MANAGE_USER_PLAYGROUND: "MANAGE_USER_PLAYGROUND",
  MANAGE_AUTHORAI_PLAYGROUND: "MANAGE_AUTHORAI_PLAYGROUND",
  HOME: 'HOME',
  MANAGE_USERS: "MANAGE_USERS",
  MANAGE_ROLES: "MANAGE_ROLES",
  MANAGE_PRIVILEGE: "MANAGE_PRIVILEGE",
  BUSINESS_CONTINUITY_MODE: "BUSINESS_CONTINUITY_MODE",
  LOGS_REVIEW_SUMMARY: "LOGS_REVIEW_SUMMARY",
  OBSERVABILITY: "OBSERVABILITY",
  MANAGE_REPOSITORY: "MANAGE_REPOSITORY",
  MANAGE_CHATBOT: "MANAGE_CHATBOT",
  MANAGE_ASKYOURDATA: "MANAGE_ASKYOURDATA",
  MANAGE_GLOBAL_CHATBOT_CONFIG: "MANAGE_GLOBAL_CHATBOT_CONFIG",
  MASTER_CONFIGURATION: "MASTER_CONFIGURATION",
  KB_DASHBOARD: "KB_DASHBOARD",
  PROMPTO: "PROMPTO",
  ARTICLE_GENERATOR: "ARTICLE GENERATOR",
  CONVERSATION_REVIEW_DISPLAY_OPTIONS: "CONVERSATION_REVIEW_DISPLAY_OPTIONS",
  RESPONSE_ACCEPTANCE: "RESPONSE_ACCEPTANCE",
  REVIEW_COMMENT: "REVIEW_COMMENT",
  REVIEW_TAB_DISPLAY_OPTIONS: "REVIEW_TAB_DISPLAY_OPTIONS",
  ASKYOURDATA: "ASKYOURDATA",
};
export const SUB_PRIVILEGES = {
  CREATE_TASKPDF: "CREATE_TASKPDF",
  EDIT_TASKPDF: "EDIT_TASKPDF",
  DELETE_TASKPDF: "DELETE_TASKPDF",
  VIEW_TASKPDF: "VIEW_TASKPDF",
  DOWNLOAD_TASKPDF: "DOWNLOAD_TASKPDF",

  CREATE_TASKAUDIO: "CREATE_TASKAUDIO",
  EDIT_TASKAUDIO: "EDIT_TASKAUDIO",
  DELETE_TASKAUDIO: "DELETE_TASKAUDIO",
  VIEW_TASKAUDIO: "VIEW_TASKAUDIO",
  DOWNLOAD_TASKAUDIO: "DOWNLOAD_TASKAUDIO",
};

export const VIEWTYPE = [
  {
    key: "PRIVATE",
    name: "Private",
    icon: "<GppGoodOutlinedIcon />",
    description: "Visible to you and your manager/supervisor",
  },
  {
    key: "DEFAULT",
    name: "Default",
    icon: "<ForkRightOutlinedIcon />",
    description:
      "Visible to you, your manager/supervisor and to your immediate reportees",
  },
  {
    key: "PUBLIC",
    name: "Public",
    icon: "<PublicOutlinedIcon />",
    description: "Visible to everyone in your hierarchy",
  },
];
export const TaskpdfHeader = [
  { name: "Side by Side", value: 'Side by Side' },
  { name: "Ask Questions", value: 'Ask Questions' },
  { name: "Original Document", value: 'Original Document' }]
export const Exter_Inter_Text = {
  external: "<b>External:</b> ",
  externalInternal: "<b>Internal/<b>External:</b></b> ", // This is for External/Internal
};
export const ColorTheme = {
  DARK_MODE: 'Dark mode',
  LIGHT_MODE: "Light mode"
}
export const CONFIG_KEY = {
  TASKPDF_THEME: 'TASKPDF_THEME',
  TASKPDF_TYPING_SIMULATION: "TASKPDF_TYPING_SIMULATION",
  ASSIST_AI_THEME: "CHATBOT_THEME",
  ASSIST_AI_TYPING_SIMULATION: "ASSIST_AI_TYPING_SIMULATION",
  ASK_YOUR_DATA_THEME: "ASK_YOUR_DATA_THEME",
  ASK_YOUR_DATA_TYPING_SIMULATION: "ASK_YOUR_DATA_TYPING_SIMULATION",
  TASKSCRIBE_THEME: "TASKSCRIBE_THEME",
  TASKSCRIBE_TYPING_SIMULATION: "TASKSCRIBE_TYPING_SIMULATION",
  INTERACTION_LOGS_TABLE_TEMPLATE:"INTERACTION_LOGS_TABLE_TEMPLATE"
}
export const DASHBOARD = {
  YESTERDAY: "Yesterday",
  TODAY: "Today",
  LAST_7_DAYS: "Last 7 days",
  THIS_MONTH: "This Month (MTD)",
  THIS_YEAR: "This Year (YTD)",
  CUSTOM: "Custom",
  DAY: "DAY",
  WEEK: "WEEK",
  MONTH: "MONTH",
  YEAR: "YEAR",
  FILTERS: "Filters",
  SINGLE: "single",
  MULTI: "multi",
  TIME_FRAME: "timeFrame",
  TIME_FRAME_PLACEHOLDER: "TimeFrame",
  DESIGNATION: "designation",
  DESIGNATION_PLACEHOLDER: "Designation",
  SELECTED_DESIGNATION: "selectedDesignation",
  SELECTED_DESIGNATION_PLACEHOLDER: "Users",
  USER_OVERVIEW: "User Overview",
  SESSIONS_OVERVIEW: "Sessions Overview",
  RESPONSES_OVERVIEW: "Responses Overview",
  CONSUMPTION_OVERVIEW: "Consumption Overview",
  TRANSCRIPTION_OVERVIEW: "Transcription Overview",
  EXCEPTION_OVERVIEW: "Exceptions Overview",
  PROMPT_OVERVIEW: "Prompt Overview",
  PROMPT_RESPONSE_OVERVIEW: "Prompt Response Overview",
  LIGHT: "light",
  DARK: "dark",
  VALID_QUERIES: "Valid Queries",
  MOST_USED_RESPONSES: "Most Used Responses",
  KNOWLEDGE_GAP_QUERIES: "Knowledge Gap Queries",
  SMALL_TALK_QUERIES: "Small Talk Queries",
  DASHBOARD_FOR: "Dashboard for",
  CUSTOM_DATE: "CUSTOM_DATE",
  SELECT_DATE: "Select Date",
  START_DATE: "Start Date",
  END_DATE: "End Date",
  SELECT: "Select",
  CANCEL: "Cancel",
  CLEAR: "Clear",
  DATE_ERROR_MESSAGE: "The start date should before or equal to the end date",
  RESET: "Reset",
  SEARCH: "Search",
  SELECT_DESIGNATION_MESSAGE: "Please select a designation",
  NO_VALUES_MESSAGE: "There are no available values",
  QUERIES: "Queries",
  USAGE_COUNT: "Usage Count",
  NO_MORE_QUERIES: "There are no more queries",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  NO_DATA: "There is no data to show",
  SESSIONS: "Sessions",
  QUERIES_PER_SESSION: "Queries Per Session",
  VALID: "Valid",
  INVALID: "Invalid",
  Overview: "Overview",
  Feedbacks: "Feedback",
  Additional_Feedbacks: "Additional Feedback",
  CARD_BLUE: "Blue",
  CARD_GREEN: "Green",
  CARD_RED: "Red",
  PRODUCT_REVIEWS: "Product Reviews",
  Thumbs_up: "Thumbs Up",
  Thumbs_down: "Thumbs Down",
  AVG_PRODUCT: "Avg. Overall Product Rating",
  AVG_KNOWLEDGE: "Avg. Knowledge Rating",
  CONV_RATING: "Conversation Rating",
  RATING_STAR: "⭐",
  Product_Feedback: 'Product Feedback',
  Conversation_Feedback: "Conversation Feedback",
  Knowledge_Assist_Product_Feedbacks: "Product Feedback - Knowledge Assist",
  DESC: "DESC",
  APPLY: "Apply",
  VIEW_RESPONSE: 'View response',
  SELECTED_SITE: 'selectedSite',
  SELECTED_SITE_PLACEHOLDER: "Sites",
  SELECTED_TL_MANAGER: "Self/Team",
  SELECTED_TL_TYPE: "SelectTl",
  FEATURES: "Features",
  QUERY: "Query",
  ID: "Id",
  TYPE: "Type",
  PLATFORM: "Platform",
  CHROME_EXT: "Chrome Extension",
  WEB: "Web",
  USER_NAME: "User Name",
  NO_OF_CALLS_TRANSCRIBED: "No. of Calls Transcribed",
  TRANSCRIPTIONS_CAPTURED: "Transcriptions Captured",
  AVERAGE_DURATION_PER_SEC: "Avg. Duration(sec)",
  AVERAGE_FIRST_RESPONSE_TIME_PER_SEC: "Avg 1st Response Time (sec)",
  CALLS: "Calls",
  CALLS_PER_SESSION: "Calls Per Session",
  CLICKS: "Clicks",
  REPONSES: "Response",
  CLICK_COUNT: "Click Count",
  VIEW_COUNT: "View Count",
  PROMPTS: "Prompts",
  SESSION: "Session",
  PROMPTS_PER_SESSION: "Prompts per session"
};

// If you found emoji issue pls install extension `:emojisense`
export const SMILE_EMOJI = {
  SMILE0: "😒",
  SMILE1: "😒",
  SMILE2: "😐",
  SMILE3: "🙂",
  SMILE4: "😁",
  SMILE5: "🤩",
};
export const PROGRESS_SMILE_EMOJI = {
  SMILE0: "😠",
  SMILE1: "😠",
  SMILE2: "😕",
  SMILE3: "🙂",
  SMILE4: "😀",
  SMILE5: "🤩",
};

export const CHART_LABEL_EMOJI = {
  STAR1: "😠 1 Star",
  STAR2: "😕 2 Star",
  STAR3: "🙂 3 Star",
  STAR4: "😀 4 Star",
  STAR5: "🤩 5 Star",
};

export const CUSTOMER_SENTIMENTS = {
  "N/A": "😶",
  NEUTRAL: "😐",
  SATISFIED: "😊",
  SAD: "😞",
  INFORMATIVE: "😊",
  CURIOUS: "🤔",
  FRUSTRATED: "😟",
  DISSATISFIED: "😞",
  ANGRY: "😠",
  CONFUSED: "😕",
  HOPEFUL: "🤞",
  HAPPY: "😃",
  CONCERNED: "😰",
  UNSURE: "😕",
  SYMPATHETIC: "🥹",
  CAUTIONS: "⚠️",
  UNDERSTANDING: "🤝",
  NERVOUS: "😰",
  OPTIMISTIC: "😌",
  INDIFFERENT: "🫤",
  "CAUTIOUSLY OPTIMISTIC": "😒",
  CAUTIOUS: "⚠️",
  APOLOGETIC: "🙂‍↕️",
  URGENT: "🤯"
}

export const CHART_NO_DATA = {
  data: [
    {
      count: 0,
      label: "",
      scale: 1
    },
    {
      count: 0,
      label: "",
      scale: 2
    },
    {
      count: 0,
      label: "",
      scale: 3
    },
    {
      count: 0,
      label: "",
      scale: 4
    },
    {
      count: 0,
      label: "",
      scale: 5
    }
  ]
}
export const CHART_RATING_STAR = {
  STAR1: "⭐",
  STAR2: "⭐⭐",
  STAR3: "⭐⭐⭐",
  STAR4: "⭐⭐⭐⭐",
  STAR5: "⭐⭐⭐⭐⭐"
}
export const CHART_HEADING_TITLE = {
  product_feedback: "Product Rating",
  quality_coherence: "Quality & Coherence",
  natural_language: "Natural Language Understanding"
}
export const CREATE_CHATBOT = {
  create_chatbot: "create_chatbot",
};

export const INSERT_SPACE_IN_STRING_REGX = /(?<=^.{1})/;

export const FILE_UPLOAD_MESSAGE = {
  CLIENT_ICON_NOTE: "Images JPG/PNG/SVG upto 10kb",
  BACKGROUND_NOTE: "Images JPEG or JPG upto 10mb",
};

export const TEXT_FIELD_VALIDATION = {
  EMAIL: "email",
  EMAIL_STRING_REGX: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  EMPLOYEE_CODE: "employee_code",
  EMPLOYEE_CODE_STRING_REGX: /^\S+$/,
  LINK: "link",
  LINK_STRING_REGX: /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/,
  LINK_WHITESPACE: /\s/,
  CHARACTER_NUMBER: /[^a-zA-Z0-9 ]/g
};

export const KB_WC_STATUS = {
  STARTED: "started",
  SUCCESS: "success",
  COMPLETED: "completed",
  FAILED: "failed",
};

export const SubjectiveFeedbackType = {
  Product_Subjective_Feedback: "Product_Subjective_Feedback",
  Positive_Subjective_Feedback: "Positive_Subjective_Feedback",
  Negative_Subjective_Feedback: "Negative_Subjective_Feedback",
};

// export const KB_WC_STEP = {
//   FILE_PROCESSING: "File Processing",
//   TEXT_EXTRACTION: "Text Extraction",
//   EMBEDDINGS_CREATING: "Embeddings Creation",
//   VECTOR_DATABASE: "Vector Database",
//   KNOWLEDGE_REPOSITORY: "Knowledge repository",
// };
export const KB_WC_STEP = {
  FILE_PROCESSING: { step: "Processing file", displayStep: "File Processing" },
  VALIDATING_FILE: { step: "validating file", displayStep: "Validating File" },
  TEXT_EXTRACTION: { step: "Extracting Text", displayStep: "Text Extraction" },
  EMBEDDINGS_CREATING: {
    step: "Creating Embeddings",
    displayStep: "Embeddings Creation",
  },
  VECTOR_DATABASE: {
    step: "Upserting to Pinecone",
    displayStep: "Vector Database",
  },
  KNOWLEDGE_REPOSITORY: {
    step: "Knowledge repository",
    displayStep: "Knowledge Repository",
  },
};
export const PDF_FORM_DATA_REQUEST = {
  FILES: "files",
  VIEW_TYPE: "viewType",
  RESPONSE: "response",
  BATCH_UID: "batchUuid",
  FILE_IDS: "fileIds",

};

export const KB_AI_FINIAL_STEP_RESPONSE = "final";

export const CHAT_DATA_VISUALIZATION = {
  FLOATING_URL: "/chatbot/floatingwidget",
  NO_MESSAGE: "no message",
  DATA_VISUALIZATION: "Data Visualization",
  TEXT: "text",
  IMAGE: "image",
  TABLE: "table",
  NEW_CONVERSATION: "New Conversation", // this constatnt will use for existing new conversation
};
export const UPLOAD_KNOWLEDGE_BASE_LIST_TYPE = [
  { name: "Upload Repository" },
  { name: "Select Repository" }
]
export const KB_SELECTION_TYPE = [
  {
    choice: "upload_repository",
    displayText: "Upload Repository",
  },
  {
    choice: "select_repository",
    displayText: "Select Repository",
  },
];
export const FILE_FORMAT_TYPE = [
  {
    choice: false,
    displayText: "Without Markdown",
  },
  {
    choice: true,
    displayText: "With Markdown",
  },
];

export const SequenceOrder = { overallProductSequence: 1, feedbackQuetionStartingSequence: 2 }

export const sequenceQuestion = { Not_Available: "Not available", Avg_Prefix: "Avg " }

export const DateFormatDashBoard = "YYYY-MM-DD"


export const KNOWLEDGE_BASE_PROGRESS_MODAL = {
  MODAL_NAME: "chatbotify",
  PROMPT_AI: "promptai",
};

export const KNOWLEDGE_BASE_FORM_DATA_REQUEST = {
  FILES: "files",
  FILE_NAME: "fileName",
  FILE_TYPE: "fileType",
  RESPONSE: "response",
  HAS_ERROR: "hasError",
  R_ID: "rid",
  MARKDOWN: "isMarkDown",
  SOURCE_TYPE_FILE_UPLOAD: "FILE_UPLOAD",
  SOURCE_TYPE_REPOSITORY: "REPOSITORY",
  FIELD_IDS: "fileIds",
};
export const SubjectiveFeedback = { No_Data: "No data available" }

export const MORE_INFO_MODAL = {
  MORE_INFO: 'More Info',
  QUESTION: 'Question',
  RESPONSE: 'Response',
  ID: 'Conversation ID',
  SUBMITTED_BY: 'Submitted By',
  SUBMITTED_AT: 'Submitted At',
  LAST_UPDATE: 'Last update',
  DONE: 'Done'
}

export const SIGNED_URL_KB_REQUEST = {
  ID_REQUEST: 'id_request',
  URL_REQUEST: 'url_request',
}
export const FEEDBACK_MODAL_DATE_OPTIONS = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true
};

export const DATE_FORMAT = {
  DDMMYYYY_HHMM: 'MMM DD YYYY, h:mm a',
  YYYYMMDD_HHMM: 'YYYY MMM DD, h:mm a',
  YYYYMMDD: 'YYYY/MM/DD',
}

export const FEEDBACK_BAR_CHART_COLOR = {
  COLOR: '#5E9AFF'
}

export const DASHBOARD_PRIVILEGES = {
  DASHBOARD: 'DASHBOARD',
  KB_DASHBOARD: 'KB_DASHBOARD',
  OVERVIEW: 'OVERVIEW',
  FEEDBACK: 'FEEDBACK',
  CONVERSATION_FEEDBACK: 'CONVERSATION_FEEDBACK',
  PRODUCT_FEEDBACK: 'PRODUCT_FEEDBACK',
  ASK_YOUR_DATA_REPORTS: "ASK_YOUR_DATA_REPORTS"
}

export const REPORT_PRODUCT = {
  KNOWLEDGE_ASSIST: { privilageName: "KNOWLEDGE_ASSIST_REPORTS", displayName: "AssistAI" },
  TASKPDF: { privilageName: "TASKPDF_REPORTS", displayName: "TASKPDF" },
}

export const REPORT_PRODUCT_ARRAY = [
  {
    choice: "KNOWLEDGE_ASSIST_REPORTS",
    reportChip: "CHATBOT",
    displayText: "AssistAI",
  },
  {
    choice: "TASKPDF_REPORTS",
    reportChip: "TASK_PDF",
    displayText: "TaskPDF",
  },
  {
    choice: "PROMPTO_REPORTS",
    reportChip: "prompto",
    displayText: "PromptAI",
  },
  {
    choice: "TASKSCRIBE_REPORTS",
    reportChip: "taskscribe",
    displayText: "AuthorAI",
  },
  {
    choice: "CALLAI_REPORTS",
    reportChip: "CALLAI",
    displayText: "CallAI",
  },
  {
    choice: "ASK_YOUR_DATA_REPORTS",
    reportChip: "askyourdata",
    displayText: "AskYourData",
  },
];

export const REPORT_TYPE = {
  KNOWLEDGE_ASSIST: 'KNOWLEDGE_ASSIST_REPORTS',
  TASKPDF: 'TASKPDF_REPORTS',
  TASKSCRIBE_REPORTS: "TASKSCRIBE_REPORTS",
  ASK_YOUR_DATA_REPORTS: "ASK_YOUR_DATA_REPORTS"
}
export const REPORT_DATA_TYPE = {
  TEXT: 'text',
  JSON: 'json'
}

export const REPORT_CHIP_TYPE = {
  TASK_PDF: 'TaskPDF',
  CHATBOT_CONVERSATION: 'CHATBOT_CONVERSATION'
};
export const CHATBOTIFY_VARIABLES = {
  KNOWLEDGEBASE: 'Knowledge Base',
  GENERAL: 'General',
  FEATURES: "Features",
  LLM: 'LLM',
  SMALL_TALK: 'Small Talk',
  MASKING: 'PII Masking',
  PLAYGROUND_INSTRUCTIONS: 'Playground Instructions',
  WELCOME_MESSAGE: 'Welcome Message',
  PROMOTE: 'Promote',
  CONFIGURATION: "Configuration",
  RESPONSE_BANK: "Response Bank",
};

export const REPORT_DATES = [
  {
    choice: '1',
    displayText: 'Today'
  },
  {
    choice: '2',
    displayText: 'Yesterday'
  },
  {
    choice: '3',
    displayText: 'Last 7 Days'
  },
  {
    choice: '4',
    displayText: 'Last 30 days'
  },
  {
    choice: '6',
    displayText: 'This Month'
  },
  {
    choice: '5',
    displayText: 'Custom'
  },
]

export const CONTENT_TYPE = {
  DOCX: 'docx',
  PDF: 'pdf'
};

export const USER_ACTION_STATES = {
  YES: 'yes',
  NO: 'no',
  EXPIRED: 'expired'
};

export const userLogReviewStatusFlag = [{ stepName: "Chatbot triggered (Help)", step: "A" }, { stepName: "IN Guardrails (Blocked or Unblocked)", step: "B" }, { stepName: "Embedding Call", step: "C" }, { stepName: "Pinecone API Call Status", step: "D" }, { stepName: "LLM Request Status", step: "E" }, { stepName: "Sent to OpenAI for Completion", step: "F" }, { stepName: "ON Guardrails (Blocked or Unblocked)", step: "G" }, { stepName: "PII Masking KickedIn", step: "H" }]

export const LOGS_REVIEW_CHART = {
  CARD_BLUE: 'Blue',

};

export const LOGS_REVIEW_PAGINATION_ARRAY = [
  {
    choice: "50",
    displayText: "50 Per Page",
  },
  {
    choice: "100",
    displayText: "100 Per Page",
  },
  {
    choice: "200",
    displayText: "200 Per Page",
  },
];

export const STEPS_STATUS = {
  COMPLETED: 'completed', // last step dark blue and other step lightblue
  NOT_STARTED: 'not started',// gray
  NOT_APPLICABLE: 'not applicable',// gray
  FAILED: 'failed', // orange
}

export const dashboard_download_queries = {
  valid_queries: "Valid Queries",
  knowledge_gap_queries: "Knowledge Gap Queries",
  small_talk_queries: "Small Talk Queries",
  queries: "Queries",
  feature: "Feature",
  most_used_responses: "Most Used Responses"
}

export const dashboard_filename_queries = {
  valid_queries: "Valid_Queries",
  knowledge_gap_queries: "Knowledge_Gap_Queries",
  small_talk_queries: "Small_Talk_Queries",
  queries: "Queries",
  feature: "Feature",
  most_used_responses: "Most_Used_Responses"
}

export const COMMENT_ACTION_TYPE = {
  COMMENTS_ADD: 'COMMENTS_ADD',
  RESPONSE_ACCEPT: 'RESPONSE_ACCEPT',
  RESPONSE_REJECT: 'RESPONSE_REJECT',
  RESPONSE_VIEW: 'RESPONSE_VIEW',

}

export const REVIEW_ACTIVITY_DROPDOWN = [
  {
    choice: "all",
    displayText: "All",
  },
  {
    choice: COMMENT_ACTION_TYPE?.RESPONSE_ACCEPT,
    displayText: "Accepted",
  },
  {
    choice: COMMENT_ACTION_TYPE?.RESPONSE_REJECT,
    displayText: "Rejected",
  },
  {
    choice: COMMENT_ACTION_TYPE?.COMMENTS_ADD,
    displayText: "Comment",
  },
];

export const response_typing = "Response typing simulation";

export const LOG_REVIEW_PRODUCT = {
  LOGSREVIEW_CHATBOT: 'LOGSREVIEW_CHATBOT',
  LOGSREVIEW_TASKSCRIBE: 'LOGSREVIEW_TASKSCRIBE',
  LOGSREVIEW_TASK_PDF: 'LOGSREVIEW_TASK_PDF',
  LOGSREVIEW_ASK_YOUR_DATA: 'LOGSREVIEW_ASK_YOUR_DATA',
}
export const RESPONSE_VIEW_SECTION = {
  RESPONSE: 'Response',
  PROMPT: 'Prompt',
  METADATA: 'Metadata',
  LLM: 'LLM',
  FEEDBACK: 'Feedback',
  CITATION: 'Citation'
}

export const DATA_LOGING_OPTIONS = [
  {
    choice: "-1",
    displayText: "Log will never be deleted",
  },
  {
    choice: "1",
    displayText: "Log will be deleted after days",
  },
  {
    choice: "0",
    displayText: "No Logging",
  },
];
export const SORT_DROPDOWN_ARRAY = [
  {
    choice: "NEW_FIRST",
    displayText: "New First",
  },
  {
    choice: "MY_FAVOURITES",
    displayText: "My Favourites",
  },
  {
    choice: "FREQUENTLY_USED",
    displayText: "Frequently Used",
  },
  {
    choice: "ASC",
    displayText: "Ascending A-Z",
  },
  {
    choice: "DESC",
    displayText: "Descending Z-A",
  },
];
export const DATE_FORMAT_TYPE = {
  DD_MM_YYYY: "DD-MM-YYYY",
  YYYY_MM_DD: "YYYY/MM/DD",
  YYYY_MM_DD_DASH: "YYYY-MM-DD",
}